<template>
  <div >
    <div class="all-users-page test-class">
      <div class="loading" v-if="downloadInProcess">
        <div class="loading-text">loading ...</div>
      </div>
      <h1 class="page-header color-1-100">All Tasks</h1>
      <div class="admin-gm-breadcrumbs">
        <router-link class="dashboard" to="/">Dashboard</router-link>
        <router-link class="companies" :to="{name: 'companies'}">Companies</router-link>
        <router-link class="all-users" :to="{name: 'users'}">Users</router-link>
        <router-link class="to-do active" :to="{name: 'todo-list'}">Tasks</router-link>
      </div>
    </div>
    <div class="content-section">
      <div class="data-list-heading">
        <div class="data-list-statusbar">
          <div class="data-list-statusbar__contains data-list-statusbar__block">{{+statusbar.published + +statusbar.archived + +statusbar.draft}} resources</div>
          <ul class="data-list-statuses data-list-statusbar__block">
            <li class="data-list-statuses__item">{{ statusbar.published }} published</li>
            <li class="data-list-statuses__item">{{ statusbar.archived }} archived</li>
            <li class="data-list-statuses__item">{{ statusbar.draft }} draft</li>
          </ul>
        </div>
        <router-link :to="{name: 'add-todo'}" class="data-list-add" tabindex="-1">Add new Task</router-link>
      </div>
      <button @click.prevent="tableExport(csvData)"
              v-if="this.editedArticles.length"
              class="csv-download-button"
      >Export all Tasks</button>
      <button @click.prevent="csvExport()"
              v-if="this.articles.length"
              class="csv-download-button"
      >Export Task/Resource documents</button>
      <div class="data-list-selected-filters" v-if="selectedFilters.length">
        <div class="data-list-selected-filters-applied">
          <span>Filters applied:<br/>{{ this.editedArticles.length }} results</span>
        </div>
        <div class="data-list-selected-filters-body">
          <button v-for="filter in selectedFilters"
                  type="button"
                  @click="removeSelectedFilters(filter)"
                  @mouseover="addHoverElement([filter])"
                  @mouseleave="removeHoverElements"
                  :class="{'hover-filter-element': isExist(filter)}">
            <span>{{ filter.label }}</span>
          </button>
          <span class="data-list-selected-filters-remove-all"
                @click="removeAllFilters"
                @mouseover="statusbar.filter.isHover = true"
                @mouseleave="statusbar.filter.isHover = false">Clear all filters</span>
        </div>
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead>
          <tr>
            <th class="articles-list-search-col text-left column-search-head table-head-ceil" colspan="2"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 1}">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                          v-model="searchByName"
                          type="search"
                          class="table-search"
                          placeholder="Search in TTDs..." />
                </div>
              </div>
              <div class="wrap-search-icon"></div>
            </th>
            <th class="column-type-head table-head-hover table-head-ceil"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 3,
                'active-ceil-head': filerTableHead.selectedCeil === 2,
                'hover-head-ceil': isExistInOptions(getContentTypeForSelect)}"
                @click.stop="showHideSubMenu(2)"
                @mouseover="addHoverElement(getContentTypeForSelect)"
                @mouseleave="removeHoverElements" >
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 2}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Type</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-2"
                   v-show="filerTableHead.selectedCeil === 2"
                   tabindex="-1"
                   @click.stop="">
                <app-select v-model="contentType"
                            placeholder="Search here ..."
                            :options="getContentTypeForSelect"
                            :multiple="true"
                            :class="'table-head-select'" />
              </div>
            </th>
            <th class="column-topics-head table-head-hover table-head-ceil"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 4,
                'active-ceil-head': filerTableHead.selectedCeil === 3,
                'hover-head-ceil': isExistInOptions(getTagsForSelect)}"
                @click.stop="showHideSubMenu(3)"
                @mouseover="addHoverElement(getTagsForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 3}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Topics</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-3"
                   v-show="filerTableHead.selectedCeil === 3"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search here ..."
                            :options="getTagsForSelect"
                            v-model="tags"
                            :multiple="true"
                            :class="'hide-selected-items'"/>
              </div>
            </th>
            <th class="column-categories-head table-head-hover table-head-ceil"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 5,
                'active-ceil-head': filerTableHead.selectedCeil === 4,
                'hover-head-ceil': isExistInOptions(getChaptersForSelect)}"
                @click.stop="showHideSubMenu(4)"
                @mouseover="addHoverElement(getChaptersForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 4}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Task category</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-4"
                   v-show="filerTableHead.selectedCeil === 4"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search here ..."
                            :options="getChaptersForSelect"
                            v-model="chapter"
                            :multiple="true"
                            :class="'hide-selected-items'"/>
              </div>
            </th>
<!--            <th class="column-access-head table-head-hover table-head-ceil"-->
<!--                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 6,-->
<!--                'active-ceil-head': filerTableHead.selectedCeil === 5,-->
<!--                'hover-head-ceil': isExistInOptions(getRolesForSelect)}"-->
<!--                @click.stop="showHideSubMenu(5)"-->
<!--                @mouseover="addHoverElement(getRolesForSelect)"-->
<!--                @mouseleave="removeHoverElements">-->
<!--              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 5}">-->
<!--                <div class="caption-head-text">-->
<!--                  <span class="caption-head-inner-text">Access</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="wrap-dropdown-table-head"-->
<!--                   id="sub-menu-5"-->
<!--                   v-show="filerTableHead.selectedCeil === 5"-->
<!--                   tabindex="-1"-->
<!--                   @click.stop="">-->
<!--                <app-select placeholder="Search here ..."-->
<!--                            :options="getRolesForSelect"-->
<!--                            v-model="roles"-->
<!--                            :multiple="true"-->
<!--                            :class="'hide-selected-items'"-->
<!--                />-->
<!--              </div>-->
<!--            </th>-->
            <th class="column-companies-head table-head-hover table-head-ceil"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 7,
                'active-ceil-head': filerTableHead.selectedCeil === 6,
                'hover-head-ceil': isExistInOptions(getCompaniesForSelect)}"
                @click.stop="showHideSubMenu(6)"
                @mouseover="addHoverElement(getCompaniesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 6}">
                <div class="caption-head-text" style="max-width: 75px;">
                  <span class="caption-head-inner-text">Company specific</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-6"
                   v-show="filerTableHead.selectedCeil === 6"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search here ..."
                            :options="getCompaniesForSelect"
                            v-model="companies"
                            :multiple="true"
                            :class="'hide-selected-items'"
                />
              </div>
            </th>
            <th class="column-industries-head table-head-hover table-head-ceil"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 8,
                'active-ceil-head': filerTableHead.selectedCeil === 7,
                'hover-head-ceil': isExistInOptions(getIndustriesForSelect)}"
                @click.stop="showHideSubMenu(7)"
                @mouseover="addHoverElement(getIndustriesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 7}">
                <div class="caption-head-text" style="max-width: 75px;">
                  <span class="caption-head-inner-text">Industry specific</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-7"
                   v-show="filerTableHead.selectedCeil === 7"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search here ..."
                            :options="getIndustriesForSelect"
                            v-model="industries"
                            :multiple="true"
                            :class="'hide-selected-items'"
                />
              </div>
            </th>
            <th class="column-created-head table-head-ceil"
                @click.stop="changeOrderBy('edited', true)">
              <div class="caption-head caption-head-order">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Last Edited</span>
                </div>
                <div class="caption-head-order-change">
                  <div class="caption-head-order-up"
                       :class="{'active': this.articleOrderBy !== null && this.articleOrderBy.type === 'edited' && this.articleOrderBy.order}"></div>
                  <div class="caption-head-order-down"
                       :class="{'active': this.articleOrderBy !== null && this.articleOrderBy.type === 'edited' && !this.articleOrderBy.order}"></div>
                </div>
              </div>
            </th>
            <th class="column-status-head table-head-hover table-head-ceil"
                :class="{'left-active-ceil-head': filerTableHead.selectedCeil === 10,
                'active-ceil-head': filerTableHead.selectedCeil === 9,
                'hover-head-ceil': isExistInOptions(getStatusesForSelect)}"
                @click.stop="showHideSubMenu(9)"
                @mouseover="addHoverElement(getStatusesForSelect)"
                @mouseleave="removeHoverElements">
              <div class="caption-head caption-head-icon" :class="{'active': filerTableHead.selectedCeil === 9}">
                <div class="caption-head-text">
                  <span class="caption-head-inner-text">Status</span>
                </div>
              </div>
              <div class="wrap-dropdown-table-head"
                   id="sub-menu-9"
                   v-show="filerTableHead.selectedCeil === 9"
                   tabindex="-1"
                   @click.stop="">
                <app-select placeholder="Search here ..."
                            v-model="status"
                            :options="getStatusesForSelect"
                            :multiple="true"
                            :class="'hide-selected-items'"/>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(article, i) in editedArticles" v-if="i < offset" @click="editArticle(article.id)">
            <td class="text-center cellpadding">
              <!--<input type="checkbox" :id="article.id"/>-->
              <label :for="article.id">{{article.id}}</label>
            </td>
            <td class="cellpadding">{{article.title}}</td>
            <td class="cellpadding text-center">{{article.content_type.type}}</td>
            <td class="cellpadding text-center">{{article.tags.length ? article.tags[0].name : ''}}</td>
            <td class="cellpadding text-center">{{article.chapter ? article.chapter.name : ''}}</td>
<!--            <td class="cellpadding text-center" v-html="articleRoles(article.roles)">-->
<!--            </td>-->
            <td class="cellpadding text-center" style="width: 105px;">
              <template v-for="company in article.companies">
                {{ company.name }} <br/>
              </template>
            </td>
            <td class="cellpadding text-center" style="width: 105px;">
              <template v-for="industry in article.industries">
                {{ industry.name }} <br/>
              </template>
            </td>
            <td class="cellpadding text-center">{{convertDate(article.updated_at, '.')}}</td>
            <td class="cellpadding text-center">
              <span class="status" :class="{'status--archived': article.status === 2, 'status--published': article.status === 1, 'status--draft': article.status === 0}">{{getStatus(article.status)}}</span>
            </td>
          </tr>
          </tbody>
        </table>
        <a href="#" id="dataDownload" style="position: fixed; left: -2000px; bottom: -2000px;">download</a>
        <div class="load-more-container" v-if="this.offset <= this.editedArticles.length">
          <div class="load-more-btn" @click="loadMore()">
            <div id="wave"><span class="dot"></span><span class="dot"></span><span class="dot"></span></div>Load more
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import AppSelect from '@/components/admin/common/Select'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'articles-list',
  data () {
    return {
      ppt: 15,
      offset: 15,
      articles: [],
      selectedAction: null,
      contentAutoloadInfo: {
        numPages: 1,
        locked: false
      },
      search: '',
      searchByName: '',
      contentType: [],
      tags: [],
      categories: [],
      chapter: [],
      roles: [],
      companies: [],
      industries: [],
      lastEdited: [],
      status: [],
      datepicker: {
        isShown: false,
        from: null,
        to: null
      },
      statusbar: {
        published: 0,
        archived: 0,
        draft: 0,
        filter: {
          isHover: false,
          style: {
            backgroundColor: '#fffdd8',
            borderColor: '#000'
          }
        }
      },
      hoverElements: [],
      filerTableHead: {
        selectedCeil: null
      },
      articleOrderBy: {
        type: 'edited',
        order: false
      },
      editedArticles: [],
      articleTypeList: [],
      articleTagList: [],
      articleCategoryList: [],
      articleChapterList: [],
      // articleRoleList: [],
      articleCompanyList: [],
      articleIndustryList: [],
      articleStatusList: [],
      downloadInProcess: false
    }
  },
  methods: {
    ...mapActions([
      'setInformationMsg'
    ]),
    csvExport () {
      this.downloadInProcess = true
      this.$http.get(api.URLS.content + '/documents/export', api.headersAuthSettings)
        .then((res) => {
          this.downloadInProcess = false
          let hiddenElement = document.getElementById('dataDownload')
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(res.body)
          hiddenElement.download = this.getDocumentsDownloadName()
          hiddenElement.click()
        })
        .catch((err) => {
          this.downloadInProcess = false
          console.log(err)
        })
    },
    tableExport (arrData) {
      let csvContent = [
        Object.keys(arrData[0]).map(function (item) {
          return '"' + item + '"'
        }).join(','),
        ...arrData.map(item => Object.values(item).map(function (item) {
          return '"' + item + '"'
        }).join(','))
      ]
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')

      let csvData = new Blob([csvContent], {
        type: 'application/csv;charset=utf-8;'
      })

      let documentName = this.getTableDataDownloadName()

      if (window.navigator.msSaveBlob) {
        navigator.msSaveBlob(csvData, documentName)
      } else {
        const csvUrl = URL.createObjectURL(csvData)
        const link = document.getElementById('dataDownload')
        link.setAttribute('href', csvUrl)
        link.setAttribute('download', documentName)
        link.click()
      }
    },
    getDocumentsDownloadName () {
      let date = new Date()
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      month = months[month - 1]
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + month + fullYear
      let timeString = toDoubleDigit(hours) + 'h' + toDoubleDigit(minutes) + 'm'
      return 'ContentDocuments' + '-' + dateString + '-' + timeString + '.csv'
    },
    getTableDataDownloadName () {
      let date = new Date()
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      month = months[month - 1]
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + month + fullYear
      let timeString = toDoubleDigit(hours) + 'h' + toDoubleDigit(minutes) + 'm'
      return 'TTDs' + '-' + dateString + '-' + timeString + '.csv'
    },
    loadMore () {
      this.offset = this.offset + this.ppt
    },
    changeOrderBy (type, order) {
      this.articleOrderBy = {
        type: type,
        order: this.articleOrderBy !== null ? !this.articleOrderBy.order : order
      }
    },
    editArticle (id) {
      let props = this.$router.resolve({
        name: 'edit-todo',
        params: {id: id}
      })
      location.href = props.href
    },
    searchByParams (page, limit) {
      this.contentAutoloadInfo.curPage = page
      let body = {
        isArticle: false
      }
      this.lastEdited.forEach((item) => {
        if (item.from) {
          body.from = item.from
        }
        if (item.to) {
          body.to = item.to
        }
      })
      this.$eventHub.$emit('load-end')
      this.$http.post(api.URLS.contentSearch + '?page=' + page + '&limit=' + limit, body, api.headersAuthSettings)
        .then((res) => {
          if (res.body.data.items.length < true) {
            this.$eventHub.$emit('load-end')
            this.$eventHub.$emit('load-stop')
          } else {
            this.$eventHub.$emit('load-start')
          }
          this.contentAutoloadInfo.curPage = res.body.data.current_page_number
          this.contentAutoloadInfo.numPages = Math.ceil(res.body.data.total_count / limit) !== 0 ? Math.ceil(res.body.data.total_count / limit) : 1
          if (page === 1) {
            this.articles = res.body.data.items
          } else {
            this.articles = [...this.articles, ...res.body.data.items]
          }
          let count = res.body.status
          this.statusbar.published = count.Published.count
          this.statusbar.draft = count.Draft.count
          this.statusbar.archived = count.Archived.count
        })
        .catch(() => {
          this.contentAutoloadInfo.locked = false
        })
    },
    getStatus (st) {
      switch (st) {
        case 0:
          return 'Draft'
        case 1:
          return 'Published'
        case 2:
          return 'Archived'
        default:
          return ''
      }
    },
    removeSelectedFilters (filter) {
      if (this.searchByName) {
        this.searchByName = ''
      }
      this.contentType.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.contentType.splice(i, 1)
          return
        }
      })
      this.categories.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.categories.splice(i, 1)
          return
        }
      })
      this.chapter.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.chapter.splice(i, 1)
          return
        }
      })
      this.tags.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.tags.splice(i, 1)
          return
        }
      })
      this.roles.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.roles.splice(i, 1)
          return
        }
      })
      this.companies.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.companies.splice(i, 1)
          return
        }
      })
      this.industries.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.industries.splice(i, 1)
          return
        }
      })
      this.lastEdited.forEach((item, i) => {
        if (item.id === null && item.label === filter.label) {
          this.lastEdited.splice(i, 1)
          return
        }
      })
      this.status.forEach((item, i) => {
        if (item.value === filter.value && item.label === filter.label) {
          this.status.splice(i, 1)
          return
        }
      })
    },
    removeAllFilters () {
      this.searchByName = ''
      this.contentType = []
      this.categories = []
      this.chapter = []
      this.tags = []
      this.roles = []
      this.companies = []
      this.industries = []
      this.lastEdited = []
      this.status = []
    },
    convertDate (payload, delimetr) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear
    },
    addHoverElement (elements) {
      this.hoverElements = elements
    },
    removeHoverElements () {
      this.hoverElements = []
    },
    isExist (element) {
      let el = this.hoverElements.find(item => {
        if ((element.value === item.value || item.value === null) && element.label === item.label) {
          return true
        }
      })
      return !!el
    },
    isExistInOptions (options) {
      let hoverElement = this.hoverElements.length ? this.hoverElements[0] : {}
      let el = options.find(item => {
        if ((hoverElement.value === item.value || hoverElement.value === null) && hoverElement.label === item.label) {
          return true
        }
      })
      return !!el
    },
    // articleRoles (roles) {
    //   let string = ''
    //   roles.forEach(role => {
    //     string += role.name + '</br>'
    //   })
    //   return string
    // },
    showHideSubMenu (num) {
      if (!this.filerTableHead.selectedCeil) {
        this.filerTableHead.selectedCeil = num
      } else {
        this.filerTableHead.selectedCeil === num ? this.filerTableHead.selectedCeil = null : this.filerTableHead.selectedCeil = num
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    }
  },
  computed: {
    ...mapGetters([]),
    csvData () {
      const dataForExport = this.editedArticles
      let self = this
      return dataForExport.map(function (item) {
        let roles = ''
        let companies = ''
        let industries = ''
        for (let i = 0; i < item.roles.length; i++) {
          roles += item.roles[i].name
          if (i < item.roles.length - 1) {
            roles += '\n'
          }
        }
        for (let i = 0; i < item.companies.length; i++) {
          companies += item.companies[i].name
          if (i < item.companies.length - 1) {
            companies += '\n'
          }
        }
        for (let i = 0; i < item.industries.length; i++) {
          industries += item.industries[i].name
          if (i < item.industries.length - 1) {
            industries += '\n'
          }
        }
        return {
          'Id': item.id,
          'Name': item.title,
          'Type': item.content_type.type,
          'Topics': item.tags.length ? item.tags[0].name : 'n/a',
          'Category': item.categories.length ? item.categories[0].title : 'n/a',
          'Access': roles,
          'Company specific': companies,
          'Industry specific': industries,
          'Last edited': self.convertDate(item.updated_at, '.'),
          'Status': self.getStatus(item.status)
        }
      })
    },
    selectedFilters () {
      let searchByName = []
      if (this.searchByName) {
        searchByName.push({
          id: null,
          type: 'name',
          label: this.searchByName
        })
      }
      return [...searchByName, ...this.contentType, ...this.categories, ...this.chapter, ...this.tags, ...this.roles, ...this.companies, ...this.industries, ...this.lastEdited, ...this.status]
    },
    getContentTypeForSelect () {
      return this.articleTypeList
    },
    getTagsForSelect () {
      return this.articleTagList
    },
    getCategoriesForSelect () {
      return this.articleCategoryList
    },
    getChaptersForSelect () {
      return this.articleChapterList
    },
    // getRolesForSelect () {
    //   return this.articleRoleList
    // },
    getCompaniesForSelect () {
      return this.articleCompanyList
    },
    getIndustriesForSelect () {
      return this.articleIndustryList
    },
    getStatusesForSelect () {
      return this.articleStatusList
    },
    filteredArticles () {
      let result = this.articles
      result = this.articles.filter((article) => (article.id + ' ' + article.title).toLowerCase().indexOf(this.searchByName.toLowerCase()) > -1)
          .filter(article => this.contentType.length === 0 || (article.content_type &&
              this.contentType.find(type => type.value === article.content_type.id)))
          .filter(article => this.companies.length === 0 || (article.companies.length &&
              this.companies.find(company => article.companies.find(articleCompany => articleCompany.id === company.value))))
          .filter(article => this.industries.length === 0 || (article.industries.length &&
              this.industries.find(industry => article.industries.find(articleIndustry => articleIndustry.id === industry.value))))
          .filter(article => this.categories.length === 0 || (article.categories.length &&
              this.categories.find(category => article.categories.find(articleCategory => articleCategory.id === category.value))))
          .filter(article => this.chapter.length === 0 || (article.chapter &&
              this.chapter.find(chapter => chapter.value === article.chapter.id)))
          .filter(article => this.tags.length === 0 || (article.tags.length &&
              this.tags.find(tag => article.tags.find(articleTag => articleTag.id === tag.value))))
          .filter(article => this.roles.length === 0 || (article.roles.length &&
              this.roles.find(role => article.roles.find(articleRole => articleRole.id === role.value))))
          .filter(article => this.status.length === 0 || (this.status.find(st => st.value === article.status)))
      if (this.articleOrderBy !== null) {
        let ascDesc = this.articleOrderBy.order ? 1 : -1
        return result.sort((a, b) => ascDesc * (new Date(a.updated_at) - new Date(b.updated_at)))
      } else {
        return result
      }
    }
  },
  watch: {
    filteredArticles () {
      this.offset = this.ppt
      let editedArticles = []
      this.articleTypeList = []
      this.articleTagList = []
      this.articleCategoryList = []
      this.articleChapterList = []
      // this.articleRoleList = []
      this.articleCompanyList = []
      this.articleIndustryList = []
      this.articleStatusList = []
      this.offset = this.ppt
      this.filteredArticles.forEach((article) => {
        if (article.content_type) {
          let index = this.articleTypeList.findIndex(x => x.value === article.content_type.id)
          if (index === -1) {
            this.articleTypeList.push({
              label: article.content_type.type,
              value: article.content_type.id
            })
          }
        }
        if (article.tags.length) {
          article.tags.forEach((tag) => {
            let index = this.articleTagList.findIndex(x => x.value === tag.id)
            if (index === -1) {
              this.articleTagList.push({
                label: tag.name,
                value: tag.id
              })
            }
          })
        }
        if (article.categories.length) {
          article.categories.forEach((category) => {
            let index = this.articleCategoryList.findIndex(x => x.value === category.id)
            if (index === -1) {
              this.articleCategoryList.push({
                label: category.title,
                value: category.id
              })
            }
          })
        }
        if (article.chapter) {
          let index = this.articleChapterList.findIndex(x => x.value === article.chapter.id)
          if (index === -1) {
            this.articleChapterList.push({
              label: article.chapter.name,
              value: article.chapter.id
            })
          }
        }
        // if (article.roles.length) {
        //   article.roles.forEach((role) => {
        //     let index = this.articleRoleList.findIndex(x => x.value === role.id)
        //     if (index === -1) {
        //       this.articleRoleList.push({
        //         label: role.name,
        //         value: role.id
        //       })
        //     }
        //   })
        // }
        if (article.companies.length) {
          article.companies.forEach((company) => {
            let index = this.articleCompanyList.findIndex(x => x.value === company.id)
            if (index === -1) {
              this.articleCompanyList.push({
                label: company.name,
                value: company.id
              })
            }
          })
        }
        if (article.industries.length) {
          article.industries.forEach((industry) => {
            let index = this.articleIndustryList.findIndex(x => x.value === industry.id)
            if (index === -1) {
              this.articleIndustryList.push({
                label: industry.name,
                value: industry.id
              })
            }
          })
        }
        let index = this.articleStatusList.findIndex(x => x.value === article.status)
        if (index === -1) {
          this.articleStatusList.push({
            label: this.getStatus(article.status),
            value: article.status
          })
        }
        editedArticles.push(article)
      })
      this.editedArticles = editedArticles
    }
  },
  mounted () {
    this.searchByParams(1, 1000)
    document.addEventListener('click', this.hideSubMenuTableHead)
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  },
  created () {
    document.title = 'All Tasks | Clear Assured'
    if (window.ga) {
      window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      window.ga('send', 'pageview', {
        'page': location.pathname,
        'location': location.href,
        'title': document.title
      })
    }
  },
  components: {
    AppSelect
  }
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// TodoList.vue?637b41e2